module.exports = __webpack_public_path__ + "static/media/shawarma.663465de.svg";